(function () {

    'use strict';

    angular.module('FotocApp')

        .component('favs', {

            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH + '../../src/') + 'editor/tools/favs.component.html',
            bindings: {},
            controller: ['$editorService', '$canvasService', '$scope', '$lang', '$window', '$timeout', function ($editorService, $canvasService, $scope, $lang, $window, $timeout) {

                var self = this;

                this.$canvasService = $canvasService;
                this.$editorService = $editorService;
                $scope.$lang = $lang;

                this.$onInit = function () {


                }




                this.select = function ($item) {

                    var new_galery = Object.assign($editorService.ui.my_galery, $item.data.images.map(function (i) {
                        return i.data
                    }));


                    new_galery = new_galery.reduce(function (rec, item){
                        var exist = rec.filter(function (k){
                            return k.uuid == item.uuid
                        }).length >= 1;

                        if(!exist){
                            rec.push(item)
                        }
                        return rec

                    }, []);


                    $editorService.ui.my_galery = new_galery;
                    $editorService.data = angular.copy($item.data);
                    $canvasService.makeFromData()

                    $timeout(function () {
                        $editorService.data = angular.copy($item.data);
                        $canvasService.makeFromData()
                    }, 0)

                    // antes preguntaba si era tiles ...
                    if ($editorService.ui.compositionsAsGroup) {
                        $editorService.ui.editingItem = 0;
                        $editorService.ui.view = {type: 'edit', id: null};
                    }
                }

                this.removeItem = function ($item) {
                    $editorService.ui.favs = $editorService.ui.favs.filter(function (item) {
                        return item !== $item;
                    })

                    $window.localStorage.setItem('editor.service.favs__' + $editorService.ui.type, JSON.stringify($editorService.ui.favs))
                }
            }]
        })
})();